import { lazy } from 'react';

export const AdminUsersPage = lazy(() => import('./AdminUsersPage'));
